import React from 'react';
import { makeStyles } from '@material-ui/styles';
import onboardingBg from '~images/onboarding-bg.png';

const useStyles = makeStyles({
  bg: {
    position: 'fixed',
    width: '100%',
    height: '100vh',
    background: `url(${onboardingBg}) no-repeat`,
    backgroundSize: 'cover',
    zIndex: -1,
  },
});

const BgImage = () => {
  const classes = useStyles();

  return <div className={classes.bg} />;
};

export default BgImage;
